import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Inici',
    component: Home
  },
  {
    path: '/treballadors',
    name: 'Treballadors',
    component: () => import(/* webpackChunkName: "treballadors" */ '../views/Treballadors.vue')
  },
  {
    path: '/clients',
    name: 'Clients',
    component: () => import(/* webpackChunkName: "clients" */ '../views/Clients.vue')
  },
  {
    path: '/projectes',
    name: 'Projectes',
    component: () => import(/* webpackChunkName: "projectes" */ '../views/Projectes.vue')
  },
  {
    path: '/dedicacions',
    name: 'Dedicacions',
    component: () => import(/* webpackChunkName: "dedicacions" */ '../views/Dedicacions.vue')
  },
  {
    path: '/despeses',
    name: 'Despeses',
    component: () => import(/* webpackChunkName: "despeses" */ '../views/Despeses.vue')
  },
  {
    path: '/pd',
    name: 'Programacions Diàries',
    component: () => import(/* webpackChunkName: "pd" */ '../views/PD.vue')
  },
  {
    path: '/resum-hores-periode',
    name: 'Resum hores període',
    component: () => import(/* webpackChunkName: "resumhoresperiode" */ '../views/ResumHoresPeriode.vue')
  },
  {
    path: '/recursos-projecte',
    name: 'Recursos a projecte',
    component: () => import(/* webpackChunkName: "recursosprojecte" */ '../views/RecursosProjecte.vue')
  },
  {
    path: '/usuaris',
    name: 'Usuaris',
    component: () => import(/* webpackChunkName: "usuaris" */ '../views/Usuaris.vue')
  },
  {
    path: '/xifres-anuals',
    name: 'Xifres anuals',
    component: () => import(/* webpackChunkName: "xifresanuals" */ '../views/XifresAnuals.vue')
  },
  {
    path: '/kpi-treballador',
    name: 'KPI treballador',
    component: () => import(/* webpackChunkName: "kpitreballador" */ '../views/KPITreballador.vue')
  },
  {
    path: '/qmi',
    name: 'QMI',
    component: () => import(/* webpackChunkName: "qmi" */ '../views/QMI.vue')
  },
  {
    path: '/pla-dedicacio',
    name: 'Pla de dedicació',
    component: () => import(/* webpackChunkName: "pla-dedicacio" */ '../views/PlaDedicacio.vue')
  },
  {
    path: '/festius-empresa',
    name: 'Festius empresa',
    component: () => import(/* webpackChunkName: "festius-empresa" */ '../views/FestiusEmpresa.vue')
  },
  {
    path: '/marge-projectes',
    name: 'Marge projectes',
    component: () => import(/* webpackChunkName: "marge-projectes" */ '../views/MargeProjectes.vue')
  },
  {
    path: '/disponibilitat-tecnica',
    name: 'Disponibilitat técnica',
    component: () => import(/* webpackChunkName: "disponibilitat-tecnica" */ '../views/DisponibilitatTecnica.vue')
  },
  {
    path: '/xifres-mensuals',
    name: 'Xifres mensuals',
    component: () => import(/* webpackChunkName: "xifres-mensuals" */ '../views/XifresMensuals.vue')
  },
  {
    path: '/backups',
    name: 'Còpies de seguretat',
    component: () => import(/* webpackChunkName: "backups" */ '../views/Backups.vue')
  },
  {
    path: '/revisor-programacio',
    name: 'Revisor programació',
    component: () => import(/* webpackChunkName: "revisor-programacio" */ '../views/RevisorProgramacio.vue')
  },
  {
    path: '/historic-revisions',
    name: 'Històric revisions',
    component: () => import(/* webpackChunkName: "historic-revisions" */ '../views/HistoricRevisions.vue')
  },
  {
    path: '/rutes',
    name: 'Rutes',
    component: () => import(/* webpackChunkName: "rutes" */ '../views/Rutes.vue')
  },
  {
    path: '/comentaris',
    name: 'Comentaris',
    component: () => import(/* webpackChunkName: "comentaris" */ '../views/Comentaris.vue')
  },
  {
    path: '/projectes-oblidats',
    name: 'Projectes oblidats',
    component: () => import(/* webpackChunkName: "projectes-oblidats" */ '../views/ProjectesOblidats.vue')
  },
  {
    path: '/conjunts-dades',
    name: 'Conjunts de dades',
    component: () => import(/* webpackChunkName: "conjunts-dades" */ '../views/ConjuntsDades.vue')
  },
]

const router = new VueRouter({
  routes
})

export default router
